import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';


class PageTab extends Component {

  handleChange(event, index, value) {
    this.props.parent.changePage(value);
  }

  next() {
    this.props.parent.changePage(this.props.parent.page + 1);
  }

  previous() {
    this.props.parent.changePage(this.props.parent.page - 1);
  }

  render() {
    var pageSize = [];
    for (var i = 1; i <= this.props.parent.pageSize; i++) {
      pageSize.push(i);
    }
    return (<table style={{width:280, position: 'absolute', left:'50%', marginLeft: -140, marginTop:8}} ><tbody><tr>
        <td width={90}>{this.props.parent.page !== 1 ? <RaisedButton label="<" onClick={this.previous.bind(this)}/> : <div></div>}</td>
        <td width={100}><SelectField
          value={this.props.parent.page}
          onChange={this.handleChange.bind(this)}
          style={{width: 70, marginLeft:10, marginTop:8}}
          labelStyle={{paddingLeft:20}}
        >
          {
            pageSize.map((nPage) => {
              return (<MenuItem value={nPage} primaryText={""+nPage} key={nPage} />)
            })
          }
        </SelectField></td>
      <td width={90}>
        {this.props.parent.page !== this.props.parent.pageSize ? <RaisedButton label=">" onClick={this.next.bind(this)}/> : <div></div>}
      </td></tr></tbody></table>);
  }
}

export default PageTab;



// WEBPACK FOOTER //
// ./src/PageTab.js